import { ActionType } from '@wix/editor-platform-host-integration-apis';

export function getActionId(
  actionType: ActionType,
  actionName: string,
): string {
  return `${actionType}:${actionName}`;
}
